import EditLotteryDetails from "./EditLotteryDetails";
export default EditLotteryDetails;
